import { render, staticRenderFns } from "./CreatorVideoIndex.vue?vue&type=template&id=3867bf04&scoped=true&"
import script from "./CreatorVideoIndex.vue?vue&type=script&lang=js&"
export * from "./CreatorVideoIndex.vue?vue&type=script&lang=js&"
import style0 from "./CreatorVideoIndex.vue?vue&type=style&index=0&id=3867bf04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3867bf04",
  null
  
)

export default component.exports